import {
  analyticsSmallViewSubmit,
  analyticsAddPendingSmallViewSubmit
} from "../../analytics/actions";
import { getPendingAnalyticsEvents } from "../../analytics/selectors";
import { getSelectedFacetValuesByFacet } from "../selectors";
import getQueryIfNewSearch from "./getQueryIfNewSearch";
import applyFacets from "./apply";
import {
  ANALYTICS_REFINEMENTS_TOGGLED,
  ANALYTICS_ADD_PENDING_EVENT
} from "../../analytics/constants";
import { createAction } from "@reduxjs/toolkit";

const updatePendingEventWithSmallViewSubmit = createAction(
  ANALYTICS_ADD_PENDING_EVENT,
  (existingPayload, smallViewSubmitPayload) => ({
    payload: {
      ...existingPayload,
      smallViewSubmitPayload
    }
  })
);

export default function done(facet, analyticsType) {
  return (dispatch, getState) => {
    const state = getState();
    const { shouldUpdate } = getQueryIfNewSearch(state);

    const selectedFacetValues = facet
      ? getSelectedFacetValuesByFacet(state, facet).filter(
          facetValue => facetValue.isSelected
        )
      : [];

    const pendingEvents = getPendingAnalyticsEvents(state);
    const hasPendingRefinementsToggled =
      pendingEvents.refinementPendingActionType ===
      ANALYTICS_REFINEMENTS_TOGGLED;

    if (shouldUpdate) {
      if (hasPendingRefinementsToggled) {
        dispatch(
          updatePendingEventWithSmallViewSubmit(pendingEvents, {
            facet,
            analyticsType,
            selectedFacetValues
          })
        );
      } else {
        dispatch(
          analyticsAddPendingSmallViewSubmit({
            facet,
            analyticsType,
            selectedFacetValues
          })
        );
      }
    } else {
      dispatch(
        analyticsSmallViewSubmit({ facet, analyticsType, selectedFacetValues })
      );
    }

    dispatch(applyFacets());
  };
}
